import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth.module'
import player from '@/store/modules/player.module'
import calendar from '@/store/modules/calendar.module'
import calendarActivity from '@/store/modules/calendar-activity.module'
import sessionHistory from '@/store/modules/session-history.module'
import dashboard from '@/store/modules/dashboard.module'
import leaderboard from '@/store/modules/leaderboard.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    player,
    calendar,
    calendarActivity,
    sessionHistory,
    dashboard,
    leaderboard
  }
})
